module.exports = __webpack_public_path__ + "img/green-unlock.d9bbe5c9.png";